import { Resources } from 'constants/resources';

import { useNotify, useUpdate } from 'react-admin';
import { Button, CancelButton } from 'shared/mui/Buttons';
import { Card, CardActionsButtons, CardHeader } from 'shared/mui/Card';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { Dialog, DialogProps } from 'shared/mui/Dialogs';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { Typography } from 'shared/mui/Typography';
import { TypographyBold } from 'shared/mui/Typography/TypographyBold';
import { ApiClient } from 'types/embedded/apiClient';

type Props = {
  onClose: VoidFunction;
  apiClient: ApiClient;
} & DialogProps;

export const ApiClientsListActiveFieldSwitchConfirmOn: React.FC<Props> = ({
  open,
  onClose,
  apiClient,
}) => {
  const notify = useNotify();
  const [update, { isLoading }] = useUpdate();
  const onSubmit = () => {
    update(
      Resources.ApiClients,
      {
        id: apiClient?.id,
        data: {
          active: true,
        },
      },
      {
        onSuccess: () => {
          notify('Клиент API успешно включен', {
            type: 'success',
            autoHideDuration: 3000,
          });
          onClose();
        },
        onError: (error) =>
          notify(`Ошибка: ${(error as Error).message || 'ошибка сервера'}`, {
            type: 'error',
            autoHideDuration: 3000,
          }),
      },
    );
  };

  return (
    <Dialog onClose={onClose} open={open} width="640px">
      <Card>
        <CardHeader
          appendActions={[<CloseIconButton key="close-button" onClose={onClose} />]}
          title="Включение клиента API"
          titleSize="smallBold"
        />
        <CardContent>
          <Typography>
            Доступ к <TypographyBold fontSize={16} text="public API" /> для клиента API{' '}
            <TypographyBold fontSize={16} text={apiClient.name} /> будет включен после
            подтверждения.
          </Typography>
        </CardContent>
        <CardActionsButtons
          rightActionsSlot={[
            <CancelButton
              key="cancel-button"
              label="отменить"
              onClick={onClose}
              variant="outlined"
            />,
            <Button
              isLoading={isLoading}
              key="save-button"
              label="Включить"
              onClick={onSubmit}
              variant="contained"
            />,
          ]}
        />
      </Card>
    </Dialog>
  );
};
